import { render, staticRenderFns } from "./AuthLoginApp.vue?vue&type=template&id=2e804c64&"
import script from "./AuthLoginApp.vue?vue&type=script&lang=ts&"
export * from "./AuthLoginApp.vue?vue&type=script&lang=ts&"
import style0 from "./AuthLoginApp.vue?vue&type=style&index=0&id=2e804c64&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports